
export enum ElementCountExpected {
    Singular = 'Singular',
    Singular_or_Plural = 'Singular_or_Plural',
    Plural = 'Plural',
    None = 'None'
}
